

export enum GroupType {
  CHANNEL = 'CHANNEL',
  PRODUCER = 'PRODUCER',
  LAYOUT = 'LAYOUT',
  BRANDSETTING = 'BRANDSETTING',
  LOGO = 'LOGO',
  LOWERTHIRD = 'LOWERTHIRD',
  TICKER = 'TICKER',
  NAMETAG = 'NAMETAG',
  FG_IMAGE = 'IMAGE',
  FG_VIDEO = 'VIDEO',
  BG_IMAGE = 'BACKGROUND_IMAGE',
  BG_VIDEO = 'BACKGROUND_VIDEO',
}


export enum ActionType {
  SELECT = 'SELECT',
  UNSELECT = 'UNSELECT',
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  RENAME = 'RENAME',
  THEME = 'THEME',
  NAMETAGS = 'NAMETAGS',
  PRIMARYCOLOR = 'COLOR',
  PRIMARYTEXT = 'PRIMARYTEXT',
  SECONDARYTEXT = 'SECONDARYTEXT',
  REORDER = 'REORDER',
  CHANGE_POSITION = 'CHANGE_POSITION',
  SWAP = 'SWAP',
  TOGGLE_LIVE = 'TOGGLE_LIVE',
  TOGGLE_SPOTTED = 'TOGGLE_SPOTTED',
  TOGGLE_MUTED = 'TOGGLE_MUTED',
  PEOPLE_UPDATE = 'PEOPLE_UPDATE'
}
